<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form>
      <div class="inner">
        <add-button
            v-if="$_createActionAllowed"
            :title="'Přidat tématickou skupinu' | translate"
            route-name="thematicGroupNew"
        ></add-button>
        <h1 v-translate>Tématické skupiny kanálů</h1>
      </div>
      <div class="inner_white">
        <div class="filter">
          <div class="field_left">
            <search-input input-class="search" v-model="formFields.search"></search-input>
          </div>
          <a @click.stop.prevent="resetFilter" class="btn btn_action btn_grey btn_reset" :title="'Resetovat filtr' | translate" v-translate>Resetovat filtr</a>
        </div>
        <form>
          <div class="scroll-wrapper">
            <div class="table_overflow" id="contentBox" data-table-id="thematic-group-list">
              <table class="vypis" ref="table_with_action_line" v-show="dataLoaded">
                <thead>
                <tr v-if="entities.length > 0">
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                  <sorting-table-title
                      v-for="title in sortingTableTitles"
                      :key="title.key"
                      :column="title.column"
                      :sort="getActiveSort(title.column)"
                      :extraStyle="title.style"
                      @changeSorting="changeSorting"
                  >{{ title.name }}
                  </sorting-table-title>
                  <th class="no_padding edit"></th>
                </tr>
                </thead>
                <thematic-group-row v-for="entity in entities"
                                    :entity="entity"
                                    :key="entity.id"
                                    :selectedEntities="selectedEntities"
                                    :all-channels="allChannels"
                                    ref="thematic_group_row"
                                    @input="select"
                                    @deleteThematicGroup="deleteEntity"
                ></thematic-group-row>
                <tr v-if="entities.length === 0">
                     <td colspan="8">{{ $gettext('Nebyly nalezeny žádné tématické skupiny.') }}</td>
                </tr>
              </table>
            </div>
          </div>
          <list-action-line
              :entities="entities"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              :offset="formFields.offset"
              :limit="formFields.limit"
              :total-count="totalCount"
              table-id="thematic-group-list"
              @select-all="toggleSelectAll"
              @run-multiple-action="runMultipleAction"
              @limit="setLimit"
              @offset="setOffset"
              ref="action_line"
          ></list-action-line>
        </form>
      </div>
    </form>
  </div>
</template>

<script>
import listActions from "../../mixins/list-actions";
import ThematicGroupRow from "./ThematicGroupRow.vue";

export default {
  name: "ThematicGroupList",
  components: {
    ThematicGroupRow
  },
  mixins: [listActions],
  data(){
    return {
      moduleName: 'thematic_groups',
      allChannels: [],
    }
  },
  created(ThematicGroupService)
  {
    this.entityService = ThematicGroupService;
    this.createdInit();
  },
  computed: {
    sortingTableTitles() {
      let result = [];
      result.push({key: 1, name: this.$gettext('Název'), column: 'sName'});
      result.push({key: 3, name: this.$gettext('Dostupné na zařízení'), column: 'sDeviceVisibility'});
      if (this.$_loggedUser_selectedOperatorId) {
        result.push({key: 4, name: this.$gettext('Systemová skupina'), column: 'sCustomGroup'});
      }
      result.push({key: 5, name: this.$gettext('Počet kanálů'), column: 'sChannelsCount'});
      result.push({key: 6, name: this.$gettext('Vytvořeno'), column: 'sDateCreated'});
      result.push({key: 7, name: this.$gettext('Upraveno'), column: 'sDateUpdated'});

      return result;
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')}
      ]
    },
    csvHeaders(){
      return this.getCsvHeaderFromSortingTableTitle(this.sortingTableTitles);
    },
  },
  methods: {
    _afterGetEntitiesActions(data){
      this.allChannels = data['all_channels'];
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/thematicGroups/ThematicGroupList.vue